import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function AdminTags() {
  const [tags, setTags] = useState([]);
  const [n, setN] = useState({ name: "", slug: "" });
  const load = async () => { const { data } = await api.get("/catalog/tags"); setTags(data); };
  useEffect(() => { load(); }, []);
  const add = async () => {
    if (!n.name || !n.slug) return;
    try { await api.post("/catalog/tags", n); setN({ name: "", slug: "" }); load(); toast.success("Eklendi"); }
    catch { toast.error("Hata"); }
  };
  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl tracking-tight">Etiketler</h1>
      <div className="bg-[#171717] border border-[#262626] rounded-lg p-4 flex gap-2">
        <input placeholder="Ad" value={n.name} onChange={(e) => setN({ ...n, name: e.target.value })}
          className="flex-1 px-3 py-2 rounded-md bg-[#0A0A0A] border border-[#262626]"/>
        <input placeholder="slug" value={n.slug} onChange={(e) => setN({ ...n, slug: e.target.value })}
          className="flex-1 px-3 py-2 rounded-md bg-[#0A0A0A] border border-[#262626]"/>
        <button onClick={add} className="px-4 py-2 rounded-md bg-[#EA580C] hover:bg-[#F97316]"><Plus size={16} className="inline"/> Ekle</button>
      </div>
      <div className="flex flex-wrap gap-2">
        {tags.map((t) => (
          <div key={t.tag_id} className="px-3 py-1.5 rounded-full border border-[#262626] text-sm">
            {t.name} <span className="text-xs text-slate-500 ml-1 font-mono">{t.slug}</span>
          </div>
        ))}
        {tags.length === 0 && <div className="text-sm text-slate-500">Etiket yok.</div>}
      </div>
    </div>
  );
}
